import React from 'react';

import {
  ContentGroup,
  Heading,
  List,
  ListItem,
  Main,
  Paragraph,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { StyledLink } from 'client/components/styledLink/StyledLink';
import Helmet from 'react-helmet';

import { LandlordInsuranceContent } from './LandlordInsurancePage.config';
import * as routes from '../manifest';

function LandlordInsurancePage() {
  const { metaContent, backLabel, title, ifYouHaveAMortgage, mightAlsoNeed } =
    useContent<LandlordInsuranceContent>();

  return (
    <Main>
      <Helmet>
        <title>{metaContent.title}</title>
      </Helmet>
      <ContentGroup marginTop="05" marginBottom="none">
        <StyledLink
          iconPosition="left"
          data-testid="back-button-link"
          to={routes.LandlordSupport}
        >
          {backLabel}
        </StyledLink>
      </ContentGroup>
      <Heading as="h1" size="s7" marginTop="05">
        {title}
      </Heading>
      <Paragraph>{ifYouHaveAMortgage}</Paragraph>

      <Heading as="h2">{mightAlsoNeed.title}</Heading>
      <List>
        {mightAlsoNeed.listItems.map((item) => (
          <ListItem key={item.split(' ')[1]}>{item}</ListItem>
        ))}
      </List>
    </Main>
  );
}

export default LandlordInsurancePage;
